import { useToast, chakra, Button,Text, useDisclosure, Box, Spinner } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FC, useState } from 'react';
import { createEmailSenderID, createSenderID } from '../../../API/account/senderId';
import { toaster } from '../../../utils/toast';
import FormInput from '../../UI/form/FormInput';
import CustomModal from '../../UI/CustomModal';
import ConfirmSenderEmail from './ConfirmSenderEmail';

const CreateEmailSenderID: FC<{ close: () => void }> = ({ close }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [emailSenderUid, setEmailSenderUid] = useState('');
  const confirmSenderEmailDisclosure = useDisclosure();



  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(createEmailSenderID, {
    onSuccess(data) {
      const success = { ...data }
      setEmailSenderUid(data.data.uid)
      toaster(toast, success)
      queryClient.invalidateQueries(['emailSenderIDData']);
      // close && close();
      confirmSenderEmailDisclosure.onOpen && confirmSenderEmailDisclosure.onOpen();
    },

    onError(data: any) {
      const errors = { ...data };
      toaster(toast, errors)
    },
  });

  return (
    <Box>
    <chakra.form
      onSubmit={(e) => {
        e.preventDefault();

        mutate({ name,email });
      }}
    >
      <FormInput
        label='Sender name'
        my='5'
        type='text'
        for='Sender name'
        formControlProps={{
          isRequired: true,
        }}
        inputProps={{
          placeholder: 'Enter sender name',
          onChange: (e) => {
            setName(e.target.value);
          },
          // max: '11',
          // isInvalid: name?.length > 11,
        }}
        // helperText={
        //   name?.length > 11
        //     ? 'Max. no. of characters exceeded'
        //     : 'Max 11 characters'
        // }
      />
      <FormInput
        label='Sender email'
        type='text'
        for='Sender email'
        formControlProps={{
          isRequired: true,
        }}
        inputProps={{
          placeholder: 'Enter sender email',
          onChange: (e) => {
            setEmail(e.target.value);
          },
          // max: '11',
          // isInvalid: name?.length > 11,
        }}
        // helperText={
        //   name?.length > 11
        //     ? 'Max. no. of characters exceeded'
        //     : 'Max 11 characters'
        // }
      />

      <Button
        isLoading={isLoading}
        // isDisabled={!name || name?.length > 11}
        w='full'
        colorScheme={'primary'}
        mt='32px'
        mb='40px'
        type='submit'
      >
        Add sender ID
      </Button>

      
    </chakra.form>

    <CustomModal
        disclosure={confirmSenderEmailDisclosure}
        title={
          <Text fontSize={"20px"} color="grays.8" mt="35px" pr="38px">
            Confirm email address
          </Text>
        }
      >
        
       
          <Box>
            <Text color={"#7489AA"} fontSize={"12px"} fontWeight={500} my={3}>
              Please enter the code sent to the email 
            </Text>
            <ConfirmSenderEmail
              close={close}
              emailSenderUid={emailSenderUid}
            />
          </Box>
       
      </CustomModal>
  
    </Box>
  );
};

export default CreateEmailSenderID;
